(function () {
  'use strict';

  var GQL_FIELDS = 'handle '
    + 'resort_name: field(key: "resort_name") { value } '
    + 'state:        field(key: "state")        { value } '
    + 'country:      field(key: "country")      { value } '
    + 'pass:         field(key: "pass_affiliation") { value } '
    + 'hero_image:   field(key: "hero_image")   { reference { ... on MediaImage { image { url altText } } } } '
    + 'resort_map:   field(key: "resort_map")   { reference { ... on MediaImage { image { url altText } } ... on GenericFile { url } } } ';

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function PAResortFinder(root) {
    this.root       = root;
    this.token      = root.dataset.token      || '';
    this.shopDomain = root.dataset.shopDomain || '';
    this.cardsInitiallyVisible = parseInt(root.dataset.cardsInitiallyVisible, 10) || 7;
    this.viewAllUrl = root.dataset.viewAllUrl || '/pages/resorts';

    try {
      this.handles = JSON.parse(root.dataset.handles || '[]')
        .map(function (h) { return h.trim(); }).filter(Boolean);
    } catch (e) { this.handles = []; }

    this.allResorts      = [];
    this.filteredResorts = [];
    this.activeFilter    = null;
    this.query           = '';
    this.allExpanded     = false;

    var sid = root.dataset.sectionId;
    this.grid        = root.querySelector('.pa-resort-finder__grid');
    this.searchInput = root.querySelector('.pa-resort-finder__search-input');
    this.chips       = Array.prototype.slice.call(root.querySelectorAll('.pa-resort-finder__chip[data-filter]'));
    this.noResults   = document.getElementById('pa-resort-finder-no-results-' + sid);
    this.showMoreWrap = document.getElementById('pa-resort-finder-show-more-' + sid);

    this._init();
  }

  PAResortFinder.prototype._init = function () {
    var self = this;
    if (!this.token || !this.handles.length) return;
    this._fetch().then(function (resorts) {
      self.allResorts = resorts;
      self._applyFilters();
      self._bindEvents();
    }).catch(function (err) {
      console.error('[PAResortFinder]', err);
    });
  };

  PAResortFinder.prototype._fetch = function () {
    var self     = this;
    var endpoint = 'https://' + this.shopDomain + '/api/2024-01/graphql.json';
    var headers  = { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': this.token };
    var collected = [];
    var cursor    = null;

    function fetchPage() {
      var after = cursor ? (', after: "' + cursor + '"') : '';
      var gql = '{ metaobjects(type: "resort_profile", first: 250' + after + ') {'
        + ' pageInfo { endCursor hasNextPage }'
        + ' nodes { ' + GQL_FIELDS + '}}}';

      return fetch(endpoint, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ query: gql })
      }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      }).then(function (json) {
        if (json.errors && json.errors.length) throw new Error(json.errors[0].message);
        var page = json.data.metaobjects;
        collected = collected.concat(page.nodes);
        if (page.pageInfo.hasNextPage) {
          cursor = page.pageInfo.endCursor;
          return fetchPage();
        }
        // Filter to only requested handles and restore textarea order
        return self.handles.map(function (h) {
          return collected.find(function (r) { return r.handle === h; }) || null;
        }).filter(Boolean);
      });
    }

    return fetchPage();
  };

  PAResortFinder.prototype._applyFilters = function () {
    var q = this.query;
    var f = this.activeFilter;
    this.filteredResorts = this.allResorts.filter(function (r) {
      var name    = ((r.resort_name && r.resort_name.value) || '').toLowerCase();
      var pass    = ((r.pass    && r.pass.value)    || '').toLowerCase();
      var state   = ((r.state   && r.state.value)   || '').toLowerCase();
      var country = ((r.country && r.country.value) || '').toLowerCase();
      if (q && name.indexOf(q) === -1) return false;
      if (f && pass.indexOf(f) === -1 && state !== f && country !== f) return false;
      return true;
    });
    this._render();
  };

  PAResortFinder.prototype._render = function () {
    var self     = this;
    var resorts  = this.filteredResorts;
    var hasQuery = this.query || this.activeFilter;
    var showAll  = this.allExpanded || hasQuery;
    var needsToggle = resorts.length > this.cardsInitiallyVisible;

    var cardsHTML = resorts.map(function (r, i) {
      var hidden = !showAll && i >= self.cardsInitiallyVisible;
      return '<li class="pa-resort-finder__item"' + (hidden ? ' hidden data-ih="1"' : '') + '>'
        + self._buildCard(r) + '</li>';
    }).join('');

    var searchAll = this.grid.querySelector('.pa-resort-finder__search-all-card');
    this.grid.innerHTML = cardsHTML;
    if (searchAll) this.grid.appendChild(searchAll);

    if (this.noResults) this.noResults.hidden = resorts.length > 0;

    if (this.showMoreWrap) {
      var moreBtn = this.showMoreWrap.querySelector('.pa-resort-finder__show-more-btn');
      var lessBtn = this.showMoreWrap.querySelector('.pa-resort-finder__show-less-btn');
      this.showMoreWrap.hidden = !needsToggle;
      if (moreBtn) moreBtn.hidden = !needsToggle || !!showAll;
      if (lessBtn) lessBtn.hidden = !this.allExpanded || !!hasQuery;
    }
  };

  PAResortFinder.prototype._buildCard = function (r) {
    var name    = (r.resort_name && r.resort_name.value) || '';
    var state   = (r.state   && r.state.value)   || '';
    var country = (r.country && r.country.value) || '';
    var pass    = (r.pass    && r.pass.value)    || '';
    var handle  = r.handle || '';
    var href    = '/pages/resorts/' + handle;

    var heroImg = r.hero_image && r.hero_image.reference && r.hero_image.reference.image;
    var mapRef  = r.resort_map && r.resort_map.reference;
    var mapImg  = mapRef && (mapRef.image || (mapRef.url ? { url: mapRef.url, altText: null } : null));
    var img     = heroImg || mapImg;

    var mediaHTML;
    if (img && img.url) {
      var base   = img.url.split('?')[0];
      var srcset = base + '?width=300 300w,' + base + '?width=500 500w,' + base + '?width=800 800w';
      mediaHTML  = '<img class="pa-photo-slot__img" src="' + base + '?width=400" srcset="' + srcset + '"'
        + ' sizes="(min-width:1200px) 300px,(min-width:990px) 25vw,(min-width:750px) 33vw,50vw"'
        + ' alt="' + esc(img.altText || name) + '" loading="lazy" width="400" height="400">';
    } else {
      mediaHTML = '<div class="pa-photo-slot__placeholder" aria-hidden="true"></div>';
    }

    var badges = '';
    if (pass) {
      var slug = pass.toLowerCase().replace(/\s+/g, '-');
      badges += '<span class="pa-pass-badge pa-pass-badge--on-image">'
        + '<span class="pa-pass-badge__dot pa-pass-badge__dot--' + esc(slug) + '" aria-hidden="true"></span>'
        + esc(pass) + '</span>';
    }

    var loc = state && country ? esc(state) + ', ' + esc(country) : esc(state || country);

    return '<a href="' + esc(href) + '" class="pa-resort-card"'
      + ' data-resort-name="' + esc(name.toLowerCase()) + '"'
      + ' data-pass="' + esc(pass.toLowerCase()) + '"'
      + ' data-state="' + esc(state.toLowerCase()) + '"'
      + ' data-country="' + esc(country.toLowerCase()) + '"'
      + ' aria-label="' + esc(name) + '">'
      + '<div class="pa-resort-card__media">' + mediaHTML + '</div>'
      + '<div class="pa-resort-card__overlay" aria-hidden="true"></div>'
      + '<div class="pa-resort-card__badges">' + badges + '</div>'
      + '<div class="pa-resort-card__body">'
      + '<p class="pa-resort-card__name">' + esc(name) + '</p>'
      + (loc ? '<p class="pa-resort-card__location">' + loc + '</p>' : '')
      + '</div></a>';
  };

  PAResortFinder.prototype._bindEvents = function () {
    var self = this;

    if (this.searchInput) {
      this.searchInput.addEventListener('input', function () {
        self.query       = this.value.toLowerCase().trim();
        self.allExpanded = false;
        self._applyFilters();
      });
    }

    this.chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var f = chip.dataset.filter;
        if (f === 'all' || f === self.activeFilter) {
          self.activeFilter = null;
          self.chips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
        } else {
          self.activeFilter = f.toLowerCase();
          self.chips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
          chip.setAttribute('aria-pressed', 'true');
        }
        self.allExpanded = false;
        self._applyFilters();
      });
    });

    if (this.showMoreWrap) {
      var moreBtn = this.showMoreWrap.querySelector('.pa-resort-finder__show-more-btn');
      var lessBtn = this.showMoreWrap.querySelector('.pa-resort-finder__show-less-btn');
      if (moreBtn) moreBtn.addEventListener('click', function () {
        self.allExpanded = true;
        self._render();
      });
      if (lessBtn) lessBtn.addEventListener('click', function () {
        self.allExpanded = false;
        self._render();
        self.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  };

  function boot() {
    document.querySelectorAll('[data-resort-finder]').forEach(function (el) {
      new PAResortFinder(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
